@if (account()) {
  <lib-menu
    [label]="accountLabel()"
    [collapseOnMobile]="collapseOnMobile()"
    [outlined]="true"
    [displayArrow]="false"
    [lightTheme]="lightTheme()"
    icon="fontawesome/user-regular"
    iconClass="fill-[--color-text-navigation]"
    data-testid="account-button"
    [buttonClass]="
      '!border-[--blue-500] lg:!border-[--color-border-primary] max-lg:!bg-gradient-to-r max-lg:!from-[--color-primary-light-from] max-lg:!to-[--color-primary-light-to] max-lg:!to-100% [&.mdc-button]:bg-[--color-background-navigation-button]'
    "
    textClass="!text-[--color-text-navigation]"
  >
    <lib-menu-item
      [menuItemLink]="{
        rawUrl: `${this.config.selfcareUrl}/${languageService.currentLanguage()}`,
      }"
    >
      <span class="font-bold text-[--color-text-navigation]"> My {{ brandService.brandName }}</span>
    </lib-menu-item>
    <lib-menu-item (clickAction)="logout()">
      <span class="font-bold text-[--color-text-navigation]">
        {{ ['dropdown', 'logout'] | translate }}
      </span>
    </lib-menu-item>
  </lib-menu>
} @else {
  <lib-link data-testid="nav-login-button" [link]="loginLink()" class="flex items-center justify-evenly">
    <div
      class="border-solid border-[0.5px] border-[--color-border-primary] rounded-full h-12 w-12 lg:w-auto lg:max-w-[10rem] xl:max-w-[8rem] flex lg:gap-2 justify-center items-center xl:mr-0 px-4 hover:bg-[--color-background-navigation-hover] bg-[--color-background-navigation-button]"
    >
      <lib-svg
        class="group-[.custom-theme]/body:fill-[--basic-white] fill-[--color-text-navigation] hidden lg:block"
        svg="fontawesome/user-regular"
      />
      <p
        class="group-[.custom-theme]/body:text-[--basic-white] text-[--color-text-navigation] font-bold text-xs xl:text-base"
      >
        {{ ['login', 'login_button_label'] | translate }}
      </p>
    </div>
  </lib-link>
}
